// @flow
import * as React from 'react';
import styled from 'styled-components';

import { below, above } from '../../assets/css/media';

export type Props = {
	sidebar_open: boolean,
	children: [React.Node, React.Node]
}

export const universalPadding = '3vw';
export const widgetsOpenWidth = '22vw';

export const TwoColumnLayoutWithSidebarWidgets = (styled.div`
    position: relative;
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-start;
	box-sizing: border-box;

	${above.tablet`
		padding: 0 ${universalPadding};
	`}

	${above.desktop`
		padding: 0 0 0 ${universalPadding};
	`}

	> :first-child {
		width: calc(100% - 100px - ${universalPadding});
		transition: width 0.3s linear;
		${props => props.sidebar_open && `
			width: calc(78% - ${universalPadding});
		`};
		${props => below.desktop`
			width: 100%;
		`}
	}

	> :last-child {
		width: 100px;
		transition: width 0.3s linear;
		${props => props.sidebar_open && `
			width: 22%;
		`};
		${props => below.desktop`
			width: 100px;
			display: flex;
			position: fixed;
			right: 0;
			top: 200px;
		`}
	}
`: React.ComponentType<Props>);

export default TwoColumnLayoutWithSidebarWidgets;


// WEBPACK FOOTER //
// ./src/components/TwoColumnLayoutWithSidebarWidgets/index.js